import styled from "styled-components";

export const sectionPadding = '20px 10px';

export const SectionMacbook = styled.section`
  background: #000;
  padding: ${sectionPadding};
  font-family: 'Agency FB';
  overflow: hidden;
  padding-bottom: 40px

  .col-mac {
    margin-left: 10px;
  }

  .col-cta {
    min-height: 500px;
  }

  .row-primary {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 768px) {
    .col-cta {
        min-height: 100px;
    }
  }
`;

export const RowCTA = styled.div`
  text-align: center;
  padding: 10px;
  h1 {
    font-family: "Rubik";
    text-align: center;
    font-size: 1.3rem;
  }

  p {
    font-family: "Rubik";
    font-size: 1.2rem;
    text-align: center;
    padding: 0 10px;
  }
   
  b {
    color: ${props => props.theme.primary};
    font-family: "Rubik";
  }
`;

export const Timeline = styled.ul`
  text-align: left;
  list-style-type: none;
  width: 173px;
`;

export const TimelineItem = styled.li`
  margin-top: 10px;
  text-decoration: none;
  position: relative;
  font-family: 'Rubik';
  cursor: pointer;
  transition: font-size 0.3s ease;
  font-family: "Rubik";
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: .7rem;
  
  b {
    padding: 7px 11px;
    border-radius: 50%;
    border: 1px solid rgb(255 255 255 / 16%);
    font-family: "Rubik";
    margin-bottom: 16px;
    margin-top: 12px;
    transition: ease-in 2s;
  }

  &::after {
    content: "";
    height: 0px; 
    width: 5px;
    position: absolute;
    background: 1px solid rgb(255 255 255 / 16%);
    left: 105px;
    top: 30px;
    border-radius: 50px;
  }

  &::before{
    content: "";
    height: 20px;
    width: 1px;
    position: absolute;
    background: rgba(255, 255, 255, 0.16);
    left: 87px;
    top: 60px;
  }

  &.active {
    font-size: 1.02rem;
    color: #1aff7a;
    b {
      background-color: #1aff7a;
      box-shadow: 3px -8px 22px #01913c;
      border: 1px solid #00c351d6;
      z-index: 2;
      color: #fff;
    }

    &::after {
      top: 45px;
      background: linear-gradient(265deg, rgb(1, 68, 29), rgb(1, 145, 61), rgb(0, 189, 79), rgb(55, 211, 104), rgb(26, 255, 122));
      height: 40px;
      transition: height 8s ease 400ms, background 5s ease 400ms;
      left: 83px;
      border-radius: 10px;
      z-index: -1px;
    }
  }

  &:last-child {
    &::after,
    &::before {
      display: none;
    }
  }
`;

export const LastTimelineItem = styled(TimelineItem)`
  &::after,
  &::before {
    display: none;
  }
`;
